import React, { useEffect, useRef, useState } from "react";
import { Notice, ListNews, Banner } from "components";
import { useDispatch, useSelector } from "react-redux";
import { isAuthenticated, getCookie} from "utils/common";
import { LIMIT, SERVICE } from "constants/global";
import { initTop } from "features/Top/topSlice";
import { Color } from "features/Top/constant";
import TabPanel from "features/Top/components/TabPanel";
import PATH from "constants/path";

const Top = () => {
  const dispatch = useDispatch();

  const refScroll = useRef();

  const [openCookie, setOpenCookie] = useState(true);
  const [isTabActive, setIsTabActive] = useState(-1);
  const [indexBackgroud, setIndexBackgroud] = useState(0);
  const [showCookie, setShowCookie] = useState(false);
  const { genre, noticesInit, newsInit, isInLine, isInLineTop, isInLineNotice, isInLineNew } = useSelector((state) => state.top);

  useEffect(() => {
    let show = getCookie("FLAG_COOKIE");
    if (show) {
      setShowCookie(show);
    }
    if (!genre) {
      dispatch(
        initTop({
          service: SERVICE,
          currentPage: 1,
          limit: LIMIT,
        })
      );
    }
  }, []);

  const moveTab = (index) => {
    // chiều ngang của thiết bị
    const screenX = refScroll.current.clientWidth;
    // số TAB
    const length = refScroll.current.childNodes.length;
    // chiều ngang mỗi TAB
    const widthTab = refScroll.current?.childNodes[0].clientWidth;

    let minIndex,
      scrollWidth = 0;
    if (!(screenX > widthTab * length)) {
      const widthTabHalf = widthTab / 2;
      // tính vị trí TAB ở giữa
      const indexXCenter = screenX / 2 / widthTab;

      // tìm vị trí nhỏ nhất có thể căn giữa
      minIndex =
        // làm tròn đơn vị
        indexXCenter % 1 > 0.5
          ? Math.round(indexXCenter)
          : Math.floor(indexXCenter) + 1;
      if (index > minIndex) {
        // tính khoảng cách để TAB di chuyển ra giữa
        scrollWidth = (index - 1) * widthTab - (screenX / 2 - widthTabHalf);
      }
    }

    refScroll.current.scrollLeft = scrollWidth;
  };

  // Click event tabs
  const onClickTabs = (item, index) => {
    moveTab(index + 1);
    setIsTabActive(item.id);
    setIndexBackgroud(index);
  };

  if (!genre && !isInLine && !isInLineTop && !isInLineNew && !isInLineNotice) return null;
  
  return (
    <>
      {!isAuthenticated() && (
        <>
          <Banner />
          <a href={PATH.LP} className="co-customer">
            <span>法人のお客様</span>
            <br />
            ご依頼はこちら
          </a>
        </>
      )}

      <div
        className={
          isAuthenticated()
            ? "w-80 py-0 py-md-3"
            : "clap container px-0 px-md-3 px-lg-0 mt-2"
        }
      >
        <Notice noticesInit={noticesInit} isInLine={isInLine || isInLineNotice}/>

        <div className="tabs-background mt-3 mt-md-4">
          <div className="fs-20 fs-sm-18 text-center fw-600 pt-2 pt-md-0 pb-1 pb-md-2">
            募集中の番組一覧
          </div>
          <ul className="tabs my-0 py-0 overflow-scroll" ref={refScroll}>
            <li
              onClick={() => onClickTabs({ id: -1 }, 0)}
              className={`tab-item ${isTabActive === -1 ? "active" : ""}`}
              style={{
                backgroundColor: Color[0].bgTab,
              }}
            >
              すべて
            </li>
            {genre?.map((item, index) => (
              <li
                key={item.id}
                className={`tab-item ${
                  item.id === isTabActive ? "active" : ""
                }`}
                onClick={() => onClickTabs(item, index + 1)}
                style={{
                  backgroundColor: Color[index + 1].bgTab,
                }}
              >
                {item.genre_name}
              </li>
            ))}
          </ul>
          <div
            className="tabs-content h-100"
            style={{ backgroundColor: Color[indexBackgroud].bgPanel }}
          >
            <TabPanel
              isTabActive={isTabActive === -1 ? true : false}
              index={-1}
              isInLine={isInLine || isInLineTop}
            />
            {genre?.map((item) => (
              <TabPanel
                key={item.id}
                isTabActive={isTabActive === item.id ? true : false}
                index={item.id}
              />
            ))}
          </div>
        </div>

        <ListNews newsInit={newsInit} isInLine={isInLine || isInLineNew}/>
      </div>

      {openCookie && !isAuthenticated() && !showCookie && (
        <div className="note active">
          <div>
            利便性向上、利用分析および広告配信等のためにクッキーを利用してアクセスデータを取得しています。
          </div>
          <div
            onClick={() => setOpenCookie(false)}
            className="btn-note cursor-pointer"
          >
            閉じる
          </div>
        </div>
      )}
    </>
  );
};

export default Top;
